export default {"src":"/_next/static/media/icon-blue-essence.9a2e1117.svg","height":20,"width":17,"blurWidth":0,"blurHeight":0};